import { TerminalApiResponse } from '@adyen/api-library/lib/src/typings/terminal/models'
import { AdyenResults } from '../../features/payment/AdyenResults'

function ResponsePanel({ hidden, response }: { hidden: boolean; response?: TerminalApiResponse }) {
	if (hidden || !response) return

	return (
		<div className="fixed inset-x-0 bottom-0 max-h-[40vh] overflow-y-auto bg-white/5 backdrop-blur-md">
			<div className="p-4 sm:px-6 lg:px-8">
				<AdyenResults formattedResponse={response} isPaymentComplete={!!response} />
			</div>
		</div>
	)
}

export { ResponsePanel }
